import type { PartialListItemStoryblok } from '@/types/component-types-sb';
import { storyblokEditable } from '@storyblok/react/rsc';

interface BulletpointsFieldData {
  list: PartialListItemStoryblok[];
  type?: BulletpointsType;
  className?: string;
}

export enum BulletpointsType {
  SUCCESS,
  WARNING,
  ERROR,
  DEFAULT,
}

const BulletpointsField: React.FC<BulletpointsFieldData> = (data) => {
  let classNames = data.className + ' bulletpoints';
  switch (data.type) {
    case BulletpointsType.SUCCESS:
      classNames += ' bulletpoints--success';
      break;
    case BulletpointsType.WARNING:
      classNames += ' bulletpoints--warning';
      break;
    case BulletpointsType.ERROR:
      classNames += ' bulletpoints--error';
      break;
  }
  return (
    <ul className={classNames}>
      {data.list.map((listItem) => (
        <li key={listItem._uid} {...storyblokEditable(listItem)}>
          {listItem.text}
        </li>
      ))}
    </ul>
  );
};

export default BulletpointsField;
